{
  "number": {
    "en": "One of the numeric values cannot be sent. Enter a valid number and try again.",
    "ar": "تعذر إرسال إحدى القيم الرقمية. أدخل رقماً صحيح الصيغة ثم أعد المحاولة."
  },
  "text": {
    "en": "Some characters cannot be saved. Re-enter the affected text and try again.",
    "ar": "تعذر حفظ بعض الأحرف. أعد إدخال النص المتأثر ثم أعد المحاولة."
  },
  "date": {
    "en": "Choose a valid date and try again.",
    "ar": "اختر تاريخاً صحيحاً ثم أعد المحاولة."
  },
  "structure": {
    "en": "The form contains a value that cannot be sent. Review the form and try again.",
    "ar": "يتضمن النموذج قيمة يتعذر إرسالها. راجع النموذج ثم أعد المحاولة."
  }
}
